import { useState } from 'react'
import { Container, Dropdown, ListGroup, NavLink, Stack, Badge } from 'react-bootstrap'
import ViewWebLink from '../Views/ViewWebLink';
import { useQuery } from 'react-query';
import { ObjectId } from '../../../models';
import { IWebLink } from '../../../models/webLink';
import { getWebLinks } from '../../../api/agent';
import DeleteDataItem from '../DeleteDataItem';
// import WebLinkStatus from './Train/WebLinkStatus';
import { useOrgContext } from '../../../context/org';
import RefreshWebLink from '../RefreshWebLink';
import { FaLink, FaEdit, FaTrash, FaEllipsisV, FaClock, FaSync } from 'react-icons/fa';
import DataStatus from '../DataStatus';

type Props = {
    orgId: ObjectId;
    webLinks: IWebLink[];
	permission: boolean;
}

function ListWebLinks({ orgId, webLinks, permission }: Props) {
    const [currWebLink, setCurrWebLink] = useState<IWebLink>();
    const [refreshWebLink, setRefreshWebLink] = useState<IWebLink>();
    const [deleteItem, setDeleteItem] = useState<{
        show: boolean;
        id: string;
        name: string;
		agentId: string;
    }>({ show: false, id: '', name: '', agentId: '' });

  return (
	<>
		{currWebLink && 
			<ViewWebLink 
				webLink={currWebLink} 
				setCurrWebLink={setCurrWebLink}
			/>
		}
		{
			<DeleteDataItem 
				show={deleteItem.show}
                onClose={() => setDeleteItem({ show: false, id: '', name: '', agentId: '' })}
                orgId={orgId}
                agentId={deleteItem.agentId}
                itemId={deleteItem.id}
                itemType="webLink"
                itemName={deleteItem.name}
			/>
		}
		{refreshWebLink && 
			<RefreshWebLink 
				orgId={orgId}
				webLink={refreshWebLink} 
				setRefreshWebLink={setRefreshWebLink}
			/>
		}
		
		<div 
			className="mb-4"
			style={{ backgroundColor: "#2d2d2d", borderRadius: "12px", border: "1px solid #444" }}
		>
			{/* Header */}
			<div className="p-4 border-bottom" style={{ borderColor: "#555" }}>
				<div className="d-flex align-items-center justify-content-between">
					<div className="d-flex align-items-center">
						<div 
							className="me-3 d-flex align-items-center justify-content-center"
							style={{
								width: "32px",
								height: "32px",
								backgroundColor: "#17a2b8",
								borderRadius: "8px"
							}}
						>
							<FaLink className="text-white" size={16} />
						</div>
						<h5 className="text-light mb-0" style={{ fontSize: "18px", fontWeight: "600" }}>
							Web Links
						</h5>
					</div>
					<Badge bg="secondary" className="px-2 py-1">
						{webLinks.length} items
					</Badge>
				</div>
			</div>

			{/* Content */}
			<div className="p-0">
				{webLinks.map((webLink, index) => (
					<div 
						key={index}
						className="p-4 d-flex align-items-center justify-content-between"
						style={{ 
							borderBottom: index < webLinks.length - 1 ? "1px solid #444" : "none",
							transition: "background-color 0.2s ease"
						}}
						onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#333"}
						onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
					>
						<div className="flex-grow-1">
							<div className="d-flex align-items-center mb-2">
								<button
									className="btn btn-link p-0 text-decoration-none text-start"
									onClick={() => setCurrWebLink(webLink)}
									style={{ 
										fontSize: "16px", 
										fontWeight: "500",
										color: "#fff",
										border: "none",
										background: "none"
									}}
									onMouseEnter={(e) => e.currentTarget.style.color = "#17a2b8"}
									onMouseLeave={(e) => e.currentTarget.style.color = "#fff"}
								>
									{webLink.url}
								</button>
							</div>
							<div className="d-flex align-items-center" style={{ fontSize: "14px", color: "#ccc" }}>
								<FaClock className="me-2" size={12} />
								<span>Updated {new Date(webLink.updatedAt).toDateString()}</span>
							</div>
						</div>

						<div className="d-flex align-items-center">
							<div className="me-3">
								<DataStatus 
									orgId={orgId} 
									id={webLink.id} 
									agentId={webLink.agentId} 
									status={webLink.status}
									type='webLink'
								/>
							</div>
							
							<Dropdown align="end">
								<Dropdown.Toggle 
									variant="link"
									className="p-0 border-0"
									disabled={permission}
									style={{ fontSize: "14px", color: "#ccc" }}
								>
									<FaEllipsisV />
								</Dropdown.Toggle>

								<Dropdown.Menu
									style={{ 
										backgroundColor: "#333", 
										borderColor: "#555",
										minWidth: "140px"
									}}
								>
									<Dropdown.Item 
										onClick={() => setCurrWebLink(webLink)}
										className="d-flex align-items-center"
										style={{ 
											fontSize: "14px", 
											color: "#fff",
											backgroundColor: "transparent"
										}}
										onMouseEnter={(e) => {
											e.currentTarget.style.backgroundColor = "#007bff";
											e.currentTarget.style.color = "#fff";
										}}
										onMouseLeave={(e) => {
											e.currentTarget.style.backgroundColor = "transparent";
											e.currentTarget.style.color = "#fff";
										}}
									>
										<FaEdit className="me-2" size={12} />
										Edit
									</Dropdown.Item>
									<Dropdown.Item 
										onClick={() => setRefreshWebLink(webLink)}
										className="d-flex align-items-center"
										style={{ 
											fontSize: "14px", 
											color: "#fff",
											backgroundColor: "transparent"
										}}
										onMouseEnter={(e) => {
											e.currentTarget.style.backgroundColor = "#17a2b8";
											e.currentTarget.style.color = "#fff";
										}}
										onMouseLeave={(e) => {
											e.currentTarget.style.backgroundColor = "transparent";
											e.currentTarget.style.color = "#fff";
										}}
									>
										<FaSync className="me-2" size={12} />
										Refresh
									</Dropdown.Item>
									<Dropdown.Item 
										onClick={() => setDeleteItem({ 
											show: true, 
											id: webLink.id, 
											name: webLink.url,
											agentId: webLink.agentId
										})}
										className="d-flex align-items-center"
										style={{ 
											fontSize: "14px", 
											color: "#fff",
											backgroundColor: "transparent"
										}}
										onMouseEnter={(e) => {
											e.currentTarget.style.backgroundColor = "#dc3545";
											e.currentTarget.style.color = "#fff";
										}}
										onMouseLeave={(e) => {
											e.currentTarget.style.backgroundColor = "transparent";
											e.currentTarget.style.color = "#fff";
										}}
									>
										<FaTrash className="me-2" size={12} />
										Delete
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>
				))}
			</div>
		</div>
	</>
  )
}

export default ListWebLinks